import { useMemo } from "react";
import { useMediaQuery } from "react-responsive";

export default function useCheckDevice() {
  const isInAppBrowser = useMemo(() => {
    const userAgent = navigator.userAgent;
    return (
      userAgent.includes("KAKAO") ||
      userAgent.includes("Instagram") ||
      userAgent.includes("NAVER") ||
      userAgent.includes("FBAN") ||
      userAgent.includes("FBAV")
    );
  }, []);

  const isPC = useMediaQuery({ query: "(min-width: 1200px)" });

  const isTablet = useMediaQuery({ query: "(min-width: 500px) and (max-width: 1199px)" });

  const isSafari = navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");

  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });

  return { isInAppBrowser, isPC, isTablet, isMobile, isSafari };
}
